import {
  CREATE_COMMITMENT,
  CREATE_COMMITMENT_FAILED,
  CREATE_COMMITMENT_SUCCESS,
  CREATE_COMMITMENT_ACTIVITY,
  CREATE_COMMITMENT_ACTIVITY_COMPLETE,
  FETCH_COMMITMENTS,
  FETCH_COMMITMENTS_COMPLETE,
  FETCH_SINGLE_COMMITMENT,
  FETCH_SINGLE_COMMITMENT_COMPLETE,
} from "./types";

export const initialState = {
  addingCommitments: false,
  addingCommitmentsActivity: false,
  fetchingCommitments: false,
  commitments: {
    data: [],
    total: 0,
  },
  selectedCommitment: null,
};

export const commitmentReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_COMMITMENTS:
      return {
        ...state,
        fetchingCommitments: true,
      };
    case FETCH_COMMITMENTS_COMPLETE:
      return {
        ...state,
        fetchingCommitments: false,
        commitments: {
          data: action?.payload?.data || [],
          total: action?.payload?.total || 0,
        },
      };
    case FETCH_SINGLE_COMMITMENT:
      return {
        ...state,
        fetchingCommitments: true,
      };
    case FETCH_SINGLE_COMMITMENT_COMPLETE:
      return {
        ...state,
        fetchingCommitments: false,
        selectedCommitment: action?.payload,
      };
    case CREATE_COMMITMENT:
      return {
        ...state,
        addingCommitments: true,
      };
    case CREATE_COMMITMENT_ACTIVITY:
      return {
        ...state,
        addingCommitmentsActivity: true,
      };
    case CREATE_COMMITMENT_ACTIVITY_COMPLETE:
      return {
        ...state,
        addingCommitmentsActivity: false,
      };
    case CREATE_COMMITMENT_FAILED:
    case CREATE_COMMITMENT_SUCCESS:
      return {
        ...state,
        addingCommitments: false,
      };

    default:
      return state;
  }
};
